export const VITE_API_GATEWAY = import.meta.env.VITE_API_GATEWAY;

export const VITE_API_REQUEST_TIMEOUT_MS = import.meta.env
  .VITE_API_REQUEST_TIMEOUT_MS;
export const VITE_APPSYNC_API = import.meta.env.VITE_APPSYNC_API;
export const VITE_AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;
export const VITE_AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const VITE_AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const VITE_AUTH0_PERMISSIONS_AUDIENCE = import.meta.env
  .VITE_AUTH0_PERMISSIONS_AUDIENCE;
export const VITE_CRONOFY_CLIENT_ID = import.meta.env.VITE_CRONOFY_CLIENT_ID;
export const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const VITE_GOOGLE_PLACES_API_KEY = import.meta.env
  .VITE_GOOGLE_PLACES_API_KEY;
export const VITE_INACTIVITY_TIMEOUT = import.meta.env.VITE_INACTIVITY_TIMEOUT;
export const VITE_MAUD_BASE_URL = import.meta.env.VITE_MAUD_BASE_URL;
export const VITE_MY_EQUIP_BASE_URL = import.meta.env.VITE_MY_EQUIP_BASE_URL;
export const VITE_NOTIFICATION_PAGE_SIZE = import.meta.env
  .VITE_NOTIFICATION_PAGE_SIZE;
export const VITE_OLD_INTAKE_SURVEY_IDS = import.meta.env
  .VITE_OLD_INTAKE_SURVEY_IDS;
export const VITE_SENDBIRD_APP_ID = import.meta.env.VITE_SENDBIRD_APP_ID;
export const VITE_SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const VITE_NOTIFICATIONS_FALLBACK_REFRESH_ENABLED = import.meta.env
  .VITE_NOTIFICATIONS_FALLBACK_REFRESH_ENABLED;
export const VITE_EQUIP_APPS_LAUNCH_DARKLY_CLIENT_SIDE_ID = import.meta.env
  .VITE_EQUIP_APPS_LAUNCH_DARKLY_CLIENT_SIDE_ID;

export const VITE_MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;
export const VITE_MAUD_APP_VERSION = import.meta.env.VITE_MAUD_APP_VERSION;
export const VITE_JUMPCLOUD_CONNECTION_NAME = import.meta.env
  .VITE_JUMPCLOUD_CONNECTION_NAME;

export const VITE_DD_APPLICATION_ID = import.meta.env.VITE_DD_APPLICATION_ID;
export const VITE_DD_CLIENT_TOKEN = import.meta.env.VITE_DD_CLIENT_TOKEN;

export const VITE_INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

export const VITE_IQ_SERVICES_API_GATEWAY = import.meta.env
  .VITE_IQ_SERVICES_API_GATEWAY;

export const VITE_MAI_WS_GATEWAY = import.meta.env.VITE_MAI_WS_GATEWAY;

export const VITE_IS_DEV = import.meta.env.DEV;
